import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkTableColInlineSize } from './types.esm.js';
import styles from './uitk-tables.css';
var getClassNameList = classNames.bind(styles);
var UitkTableCol = function (props) {
  var className = props.className,
    inlineSize = props.inlineSize,
    attributes = __rest(props, ["className", "inlineSize"]);
  var baseClassName = 'uitk-table-col';
  var colClassNames = getClassNameList(baseClassName, inlineSize && "".concat(baseClassName, "-").concat(UitkTableColInlineSize.get(inlineSize)), className);
  return React.createElement("col", __assign({
    className: colClassNames
  }, attributes));
};
UitkTableCol.displayName = 'UitkTableCol';
export { UitkTableCol };